import mutations from './mutations'
import actions from './actions'
export default {
  namespaced: true,
  state: {
    currentStation: null, // 目前站點名稱
    workStationList: [], // 跟 workStationMap 儲存的東西是一樣的，只是資料型態不一樣，儲存所有的 workStation
    workStationMap: {},
    isWorkMainChannel: true
  },
  getters: {

  },
  mutations,
  actions
}
